webpackJsonp([17],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Styles
__webpack_require__(217);

// Dependencies
var $ = __webpack_require__(0);
var cookies = __webpack_require__(3);

// Is Visible
function isVisible() {
    return cookies.read("guide-visible") !== null;
}

// Show
function show() {
    console.info("Hide guide with 'SHIFT + CTRL + ALT + G' shortcut.");
    cookies.create("guide-visible", "1", 30);

    var $guide = $('<div class="guide"></div>');
    $guide.appendTo($('body'));

    var $site = $('<div class="guide__site"></div>');
    $site.appendTo($guide);

    var $grid = $('<div class="guide__grid"></div>');
    for (var i = 1; i < 12; i++) {
        $grid.append('<div class="guide__grid-col"></div>');
    }
    $grid.appendTo($site);
};

// Hide
function hide() {
    cookies.create("guide-visible", "", -1);
    $('.guide').remove();
};

// Keyboard shorcut
// SHIFT + CTRL + ALT + G
var shortcut = function shortcut(e) {
    if (e.ctrlKey && e.shiftKey && e.altKey && e.keyCode == 71) {
        if (isVisible()) {
            hide();
        } else {
            show();
        }
    }
};
document.addEventListener('keyup', shortcut, false);

// Show if visible
if (isVisible()) {
    show();
}

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[216]);


// WEBPACK FOOTER //
// com-guide.js